import { useState,useEffect } from "react";
import "./SponsorshipSection.css";
// import { getSocialLinks } from "../../api/public.api";

const sponsorships = [
  {
    name: "Quetta Gladiators",
    role: "Titanium Sponsor",
    years: "2023",
    logo: "/images/icon-sponsor-1.svg",
  },
  {
    name: "Sunrisers Eastern Cape",
    role: "Title Sponsor",
    years: "2023 – 2024",
    logo: "/images/icon-sponsor-2.svg",
  },
  {
    name: "Deccan Gladiators",
    role: "Title Sponsor",
    years: "2023 – 2024",
    logo: "/images/icon-sponsor-3.svg",
  },
  {
    name: "St Kitts & Nevis Patriots",
    role: "Principle Sponsor",
    years: "2024 – 2025",
    logo: "/images/icon-sponsor-4.svg",
  },
  {
    name: "Biratnagar Kings",
    role: "Back of Jersey Sponsor",
    years: "2024 – 2025",
    logo: "/images/icon-sponsor.svg",
  },
];
const brand = [
  {
    name: "Manchester United",
    role: "Principal Shirt Sponsor",
    years: "2023 – 2024",
    logo: "/images/icon-ambassador-5.svg",
  },
  {
    name: "FC Barcelona",
    role: "Main Shirt Sponsor",
    years: "2023 – 2024",
    logo: "/images/icon-ambassador-4.svg",
  },
  {
    name: "Paris Saint-Germain",
    role: "Front of Shirt Sponsor",
    years: "2022 – 2024",
    logo: "/images/icon-ambassador-3.svg",
  },
  {
    name: "AC Milan",
    role: "Sleeve Sponsor",
    years: "2024 – 2025",
    logo: "/images/icon-ambassador-4.svg",
  },
  {
    name: "Borussia Dortmund",
    role: "Back of Shirt Sponsor",
    years: "2024 – 2025",
    logo: "/images/icon-ambassador.svg",
  },
];
const partners = [
  {
    logo: "/images/OfficialBrandPartners.svg",
  },
  {
    logo: "/images/OfficialBrandPartners.svg",
  },
];
const GamingLicense = [
  {
    logo: "/images/Anjouan.svg",
  },
  {
    logo: "/images/GamingLicense.svg",
  },
  {
    logo: "/images/Montenegro.svg",
  },
];
const ResponsibleGaming = [
  {
    logo: "/images/regulations.svg",
  },
  {
    logo: "/images/gamcare.svg",
  },
  {
    logo: "/images/age-limit.svg",
  },
];
const social = [
  {
    logo: "/images/icon-facebook.svg",
  },
  {
    logo: "/images/icon-pinterest.svg",
  },
  {
    logo: "/images/icon-imo.svg",
  },
  {
    logo: "/images/icon-telegram-channel.svg",
  },
  {
    logo: "/images/icon-tiktok.svg",
  },
  {
    logo: "/images/icon-whatsapp.svg",
  },
  {
    logo: "/images/icon-twitter.svg",
  },
  {
    logo: "/images/icon-youtube.svg",
  },
  {
    logo: "/images/icon-instagram.svg",
  },
];
const SOCIAL_ICONS = {
  facebook: "/images/icon-facebook.svg",
  whatsapp: "/images/icon-whatsapp.svg",
  telegram: "/images/icon-telegram-channel.svg",
  instagram: "/images/icon-instagram.svg",
  youtube: "/images/icon-youtube.svg",
};
export default function Sponsorships() {
  const [socialLinks, setSocialLinks] = useState(null);
  const [expanded, setExpanded] = useState(false);
  // useEffect(() => {
  //   const fetchSocialLinks = async () => {
  //     try {
  //       const res = await getSocialLinks();

  //       // PDF: response is array, take first object
  //       if (Array.isArray(res.data) && res.data.length > 0) {
  //         setSocialLinks(res.data[0]);
  //       }
  //     } catch (error) {
  //       console.error("Social link API error:", error);
  //     }
  //   };

  //   fetchSocialLinks();
  // }, []);
  return (
    <>
      <section className="sponsorships">
        <h2 className="title-spon">Sponsorships</h2>

        <div className="grid">
          {sponsorships.map((item, index) => (
            <div className="card-spon" key={index}>
              <img width={34} src={item.logo} alt={item.name} className="logos" />

              <div className="info">
                <h3>{item.name}</h3>
                <p className="role">{item.role}</p>
                <p className="years">{item.years}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="brand">
        <h2 className="title-spon">Brand Ambassadors</h2>

        <div className="grid">
          {brand.map((item, index) => (
            <div className="card-spon" key={index}>
              <img width={34}  src={item.logo} alt={item.name} className="logos" />

              <div className="info">
                <h3>{item.name}</h3>
                <p className="role">{item.role}</p>
                <p className="years">{item.years}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="brand">
        <h2 className="title-spon">Official Brand Partner</h2>

        <div className="grid">
          {partners.map((item, index) => (
            <div className="card-spon" key={index}>
              <img
                width={75} 
                src={item.logo}
                alt={item.name}
                className=""
              />
            </div>
          ))}
        </div>
      </section>
      <section className="brand">
        <h2 className="title">Gaming License</h2>

        <div className="grid-lic">
          {GamingLicense.map((item, index) => (
            <div className="card-spon" key={index}>
              <img width={75} src={item.logo} alt={item.name} className="" />
            </div>
          ))}
        </div>
      </section>
      <section className="brand">
        <h2 className="title-spon">Responsible Gaming</h2>
        <div className="grid-lic">
          {ResponsibleGaming.map((item, index) => (
            <div className="card-spon" key={index}>
              <img width={30} src={item.logo} alt={item.name} className="" />
            </div>
          ))}
        </div>

        <div className="social">
          {social.map((item, index) => (
            <div className="card-spon" key={index}>
              <img width={30} src={item.logo} alt={item.name} className="" />
            </div>
          ))}
        </div>
        {/* <div className="social">
          {Object.entries(SOCIAL_ICONS).map(([key, icon]) => {
            const url = socialLinks[key];
            if (!url) return null;

            return (
              <div className="card-spon" key={key}>
                <a href={url} target="_blank" rel="noreferrer">
                  <img
                    src={icon}
                    alt={key}
                    width={50}
                    className="social-icon"
                  />
                </a>
              </div>
            );
          })}
        </div> */}
      </section>

      <section className="content-wrapper">
        <div className={`content ${expanded ? "expanded" : ""}`}>
          <h2>
            Baji Bangladesh – Leading Online Gaming and Betting Platform in
            Bangladesh
          </h2>

          <p>
            In recent years, the online gaming and betting industry in
            Bangladesh has seen exponential growth, attracting players seeking
            excitement, entertainment, and secure digital platforms. With
            increasing internet penetration and mobile accessibility, users now
            enjoy seamless gaming experiences from anywhere at any time.
          </p>

          <p>
            Baji Bangladesh has emerged as a trusted name in the industry,
            offering a wide range of sports betting, live casino games, and
            exclusive promotions tailored for Bangladeshi users.
          </p>
        </div>

        {!expanded && (
          <div className="fade-overlay">
            <button
              className="show-more-btn2"
              onClick={() => setExpanded(true)}
            >
              Show more
            </button>
          </div>
        )}

        {expanded && (
          <div className="collapse-btn-wrapper">
            <button
              className="show-more-btn2"
              onClick={() => setExpanded(false)}
            >
              Show less
            </button>
          </div>
        )}
      </section>
      <section className="compliance-wrapper">
        <div className="ft">
          <img className="imagefooter" src="/images/logoBaji.png" alt="" />
          <div className="slogan-wrap">
            <span className="slogan">Win Like A King</span>
            <span className="copyrights">
              © 2026 Baji Copyrights. All Rights Reserved
            </span>
          </div>
        </div>
      </section>
      <section className="compliance-wrapper">
        <p>
          <span className="highlight">Baji.com</span> is owned and operated by
          Northern Lights Limited Holdings Limited. registration number: 15839,
          registered address: Hamchhako, Mutsamudu, Autonomous Island of
          Anjouan, Union of Comoros.
        </p>

        <p>
          Contact us{" "}
          <a
            href="mailto:northernlightslimited81@gmail.com"
            className="highlight"
          >
            northernlightslimited81@gmail.com
          </a>
          .
        </p>

        <p>
          <span className="highlight">Baji.com</span> is licensed and regulated
          by the Government of the Autonomous Island of Anjouan, Union of
          Comoros and operates under License No. ALSI-202410030-FI1.{" "}
          <span className="highlight">Baji.com</span> has passed all regulatory
          compliance and is legally authorized to conduct gaming operations for
          any and all games of chance and wagering.
        </p>
      </section>
    </>
  );
}
